var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "global-navi-menu-list" },
    [
      _vm.viewerId
        ? _c("side-menu-profile", {
            attrs: { active: _vm.active },
            on: {
              loaded: function ($event) {
                return _vm.$emit("content-changed")
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.viewerId && _vm.loginUrl
        ? _c("side-menu-login", { attrs: { "login-url": _vm.loginUrl } })
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.menuGroups, function (menuGroup) {
        return _c(menuGroup, {
          key: menuGroup.name,
          ref: menuGroup.name,
          refInFor: true,
          tag: "component",
          attrs: { active: _vm.active },
          on: {
            "content-changed": function ($event) {
              return _vm.$emit("content-changed")
            },
          },
        })
      }),
      _vm._v(" "),
      _c("side-menu-footer"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }